import { Box, Typography, useTheme } from '@material-ui/core';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import GridLayout from 'components/molecules/GridLayout';
import { PriceType } from 'constants/priceType';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { formatNumberWithCommas } from 'utils/format_number';
import {
  ITabContentProps,
  PriceOptions as PriceOptionsForSale,
  PriceOptionsForRent,
  PriceTypeOptions,
  PropertyFilterType,
  ValueForRent,
} from '../configuration';
import ProductFilterActions from '../store/actions';
import SelectField from './SelectField';

const TabPrice = (props: ITabContentProps) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const dataValuePrice = props.selections[PropertyFilterType.Price];
  const offerType =
    props.selections[PropertyFilterType.PropertyType].data.offerType;
  const PriceOptions =
    offerType === ValueForRent ? PriceOptionsForRent : PriceOptionsForSale;
  const isChecked = (currentKey: string) => {
    var isChecked = false;
    for (let key of Object.keys(dataValuePrice.data))
      if (key !== currentKey)
        isChecked = isChecked || _.get(dataValuePrice.data, key, null);
    return isChecked;
  };

  const onValueChange = (key: string, value: string | number | null) => {
    const dataCheckPriceType: any = {};
    if (value === 'null') value = null;
    if (
      (key === 'minPrice' || key === 'maxPrice') &&
      value !== null &&
      dataValuePrice.data.priceType === null
    ) {
      dataCheckPriceType['priceType'] = PriceType.SinglePrice;
    }
    dispatch(
      ProductFilterActions.setFiltersSelectionAction({
        ...props.selections,
        [PropertyFilterType.Price]: {
          ...dataValuePrice,
          ...(isChecked(key) || value
            ? { isChecked: true }
            : { isChecked: false }),
          data: {
            ...dataValuePrice.data,
            [key]: value,
            ...dataCheckPriceType,
          },
        },
      })
    );
  };

  return (
    <Box>
      <Typography
        style={{
          fontWeight: 700,
          fontSize: '16px',
          lineHeight: '20px',
          marginBottom: '4px',
        }}
      >
        <TranslatedTextV2 translationKey={''} defaultText={'Price'} />
      </Typography>
      <Typography
        style={{
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '16px',
          color: theme.palette.text.secondary,
          marginBottom: '18px',
        }}
      >
        <TranslatedTextV2
          translationKey={''}
          defaultText={'Select one or more'}
        />
      </Typography>
      <GridLayout
        spacing={0}
        elements={[
          {
            id: 'priceType',
            rowStyle: { marginBottom: '28px' },
            size: 12,
            element: (
              <SelectField
                label={{ translationKey: '', defaultText: 'Price Type' }}
                options={PriceTypeOptions}
                onValueChange={onValueChange}
                field={'priceType'}
                value={
                  props.selections[PropertyFilterType.Price].data.priceType
                }
              />
            ),
          },
          {
            id: 'minPrice',
            rowStyle: { marginBottom: '28px' },
            size: 12,
            element: (
              <SelectField
                label={{ translationKey: '', defaultText: 'Min Price' }}
                options={PriceOptions.filter((item) => item.id !== 0)
                  .filter(
                    (item) =>
                      item.id <=
                        (dataValuePrice.data?.maxPrice ||
                          PriceOptions[PriceOptions.length - 1].id) ||
                      dataValuePrice.data?.maxPrice === 0
                  )
                  .map((item) => ({
                    id: item.id,
                    label:
                      item.id === 0
                        ? 'No min'
                        : `€${formatNumberWithCommas(parseInt(item.label))}`,
                  }))}
                onValueChange={onValueChange}
                field={'minPrice'}
                value={props.selections[PropertyFilterType.Price].data.minPrice}
              />
            ),
          },
          {
            id: 'maxPrice',
            rowStyle: { marginBottom: '28px' },
            size: 12,
            element: (
              <SelectField
                label={{ translationKey: '', defaultText: 'Max Price' }}
                options={PriceOptions.filter((item) => item.id !== 0)
                  .filter(
                    (item) => item.id >= (dataValuePrice.data?.minPrice || 0)
                  )
                  .map((item) => ({
                    id: item.id,
                    label:
                      item.id === 0
                        ? 'No max'
                        : `€${formatNumberWithCommas(parseInt(item.label))}`,
                  }))}
                onValueChange={onValueChange}
                field={'maxPrice'}
                value={props.selections[PropertyFilterType.Price].data.maxPrice}
              />
            ),
          },
        ]}
      />
    </Box>
  );
};

export default TabPrice;
